import { render } from "./App.vue?vue&type=template&id=9a9e5622"
const script = {}

import "./App.vue?vue&type=style&index=0&id=9a9e5622&lang=scss"

import exportComponent from "/Users/yangshaohua/work/workspace/school-b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__